module.exports = __webpack_public_path__ + "../resources/images/celebrate-e59677151b49c4c65ef569493fa82b86.svg";